import styled from "styled-components";

export const Container = styled.div`
  max-width: 70rem;
  margin: 4rem auto 0;
`;
